import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, MenuItem, Select } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useStore } from "../../../../Store/useStore";
import { Stage } from "../../../../Domain/Aggregates/CompetitionStructure/Stage";
import { Athlete } from "../../../../Domain/Aggregates/Shared/Athlete";
import { AthleteCountText } from "./AthleteCountText";
import { DeleteAthleteRow } from "./DeleteAthleteRow";


interface EditGroupModalProps {
	groupToBeEdited: Stage;
	close: () => void;
}

export const EditGroupModal = ({ groupToBeEdited, close }: EditGroupModalProps) => {

	const [requiredNumberOfAthletes] = useState<number>(groupToBeEdited.Athletes.length);
	const [allAthletesSelected, setAllAthletesSelected] = useState(true);
	const [athletes, setAthletes] = useState<Athlete[]>(groupToBeEdited.Athletes);

	const selectedCompetition = useStore((state) => state.selectedCompetition);


	useEffect(() => {
		setAllAthletesSelected(athletes.length === requiredNumberOfAthletes);
	}, [athletes, athletes.length]);

	// const confirmModalSettings = useStore((state) => state.confirmModalSettings);
	// const onConfirmModalCancelClicked = useStore((state) => state.onConfirmModalCancelClicked);
	// const onConfirmModalConfirmClicked = useStore((state) => state.onConfirmModalConfirmClicked);

	const onDeleteAthlete = useCallback((athleteIdToRemove: number) => {
		setAthletes((prev) => prev.filter(x => x.Id !== athleteIdToRemove));
	}, [athletes]);

	return (
		<Dialog open={true} maxWidth="sm" fullWidth>
			<DialogTitle>Edit {groupToBeEdited.Name}</DialogTitle>
			<DialogContent sx={{ mt: 1 }}>

				<Box>
					{athletes.map((athlete: Athlete) => (
						<DeleteAthleteRow
							key={athlete.Id}
							athlete={athlete}
							onClick={onDeleteAthlete}
						/>
					))}
				</Box>

				<Divider sx={{ my: 2 }} />

				<AthleteCountText
					allAthletesSelected={allAthletesSelected}
					atheteCount={athletes.length}
					requiredNumberOfAthletes={requiredNumberOfAthletes}
				/>

				<Divider sx={{ my: 2 }} />

				<Box display="flex" justifyContent="center">
					<FormControl variant="outlined" fullWidth size="small" sx={{ maxWidth: "250px" }}>
						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select"
							value={10}
							disabled={allAthletesSelected}
							// onChange={handleChange}
						>
							<MenuItem value={10}>Aivars Smaukstellis Ghant</MenuItem>
							<MenuItem value={2}>Twenty</MenuItem>
							<MenuItem value={3}>Thirty</MenuItem>
						</Select>
					</FormControl>
					<Button variant="contained" color="success" disabled={allAthletesSelected}>
						Add
					</Button>
				</Box>
			</DialogContent>

			<DialogActions>
				<Button color="success" onClick={close}>Save</Button>
				<Button color="warning" onClick={close}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};
